import { saveOauth2QueryBackup } from "@/modules/Auth/service/oauth2QueryBackupService";

export function login (continueUrl) {
    let loginUrl = process.env.VUE_APP_NEST_URL + '/login';
    if (continueUrl) {
        loginUrl += '?continue=' + continueUrl;
    }
    window.location.replace(loginUrl);
}

export function loginForOauth (query) {
    // Save original OAuth2 query using dedicated service.
    // Take it from the target route, not from window.location: when the query has just been
    // restored from the backup (another round after Nest), the router has not updated the URL yet.
    saveOauth2QueryBackup(query ? new URLSearchParams(query).toString() : undefined);

    // Build continue URL as the same address without current query params
    const {origin, pathname, hash} = window.location;
    const continueUrl = origin + pathname + (hash || '');

    // Redirect to Nest login with continue parameter.
    // Use a microtask delay to ensure storage writes are fully flushed before navigating away.
    setTimeout(() => login(encodeURIComponent(continueUrl)), 0);
}

export function supports(loginMethod) {
    return loginMethod === 'NEST';
}

export default {
    login,
    loginForOauth,
    supports,
}
